export enum MULTIPLEX_DISEASES {
  COVID_19 = "COVID-19",
  FLU_A = "Flu A",
  FLU_B = "Flu B",
  RSV = "RSV",
  HIV = "HIV",
  SYPHILIS = "Syphilis",
  FLU_A_AND_B = "Flu A and B",
  HEPATITIS_C = "Hepatitis C",
  GONORRHEA = "Gonorrhea",
  CHLAMYDIA = "Chlamydia",
}

export enum TEST_RESULTS {
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
  UNDETERMINED = "UNDETERMINED",
  UNKNOWN = "UNKNOWN",
}

export enum TEST_RESULTS_SNOMED {
  POSITIVE = "260373001",
  NEGATIVE = "260415000",
  UNDETERMINED = "455371000124106",
}
